import React, { useState, useCallback, useEffect } from "react";
import axios from "axios";
import "../../css/PaginaNosotros/Pagenosotros.css"
import { Box, Typography, Container, Grid, CircularProgress} from "@mui/material"; // Importa Typography de Material UI



export const PortadaNosotros = () => {
  const [loading, setLoading] = useState(false);
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const [nosotros, setNosotros] = useState([]);

     const fetchSliders = useCallback(async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${backendURL}/api/portada-nosotros/public`);
      setNosotros(response.data[0]);
      setLoading(false)
    } catch (error) {
      console.error("Error al obtener sliders:", error);
    }
  }, [backendURL]);

  // Llamada inicial a sliders cuando hay token
  useEffect(() => {

    fetchSliders();

  }, [fetchSliders]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress size={80} thickness={6} /> {/* Hacemos el CircularProgress más grande */}
        </Box>
      </div>
    );
  }
  return (
    <Container maxWidth='lg'
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        marginTop: '200px',
          '@media (max-width:700px)': {
         marginTop: '130px',
    },
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "#fff",
          marginBottom: '50px'

        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontFamily: "Montserrat, sans-serif", // Establece la tipografía
            fontWeight: "400", // Puedes ajustar el peso si lo necesitas
            fontSize: "3rem", // Ajusta el tamaño según lo desees
            letterSpacing: "2px", // Espaciado entre letras
            textTransform: "uppercase", // Hace que el texto esté en mayúsculas
            color: "#1A425B", // Asegúrate de que sea blanco sobre el fondo oscuro
            marginRight: '10px',
              '@media (max-width:950px)': {
        fontSize: "2.5rem",
    },
    '@media (max-width:500px)': {
        fontSize: "2rem",
    },
    '@media (max-width:400px)': {
        fontSize: "1.3rem",
    },
          }}>
          sobre
        </Typography>
        <Typography
          variant="h2" // Tamaño grande para el título
          sx={{
            fontFamily: "Montserrat, sans-serif", // Establece la tipografía
            fontWeight: "700", // Puedes ajustar el peso si lo necesitas
            fontSize: "3rem", // Ajusta el tamaño según lo desees
            letterSpacing: "2px", // Espaciado entre letras
            textTransform: "uppercase", // Hace que el texto esté en mayúsculas
            color: "#1A425B", // Asegúrate de que sea blanco sobre el fondo oscuro
             '@media (max-width:950px)': {
        fontSize: "2.5rem",
    },
      '@media (max-width:500px)': {
        fontSize: "2rem",
    },

    '@media (max-width:400px)': {
        fontSize: "1.3rem",
    },
          }}
        >
          Nosotros
        </Typography>
      </Box>
      <Box>
        <Typography
          variant="h4" // Tamaño grande para el título
          sx={{
            fontFamily: "Montserrat, sans-serif", // Establece la tipografía
            fontWeight: "600", // Puedes ajustar el peso si lo necesitas
            textAlign: 'center',
            color: "#1A425B", // Asegúrate de que sea blanco sobre el fondo oscuro
             '@media (max-width:950px)': {
        fontSize: "1.5rem",
    },
     '@media (max-width:600px)': {
        fontSize: "1.3rem",
    },
    '@media (max-width:400px)': {
        fontSize: "1rem",
    },
          }}
        >
         {nosotros.titulo}
        </Typography>
        <Typography
          variant="h4" // Tamaño grande para el título
          sx={{
            fontFamily: "Montserrat, sans-serif", // Establece la tipografía
            fontWeight: "400", // Puedes ajustar el peso si lo necesitas
            textAlign: 'center',
            color: "#1A425B", // Asegúrate de que sea blanco sobre el fondo oscuro
             '@media (max-width:950px)': {
        fontSize: "1.5rem",
    },
     '@media (max-width:600px)': {
        fontSize: "1.3rem",
    },
    '@media (max-width:400px)': {
        fontSize: "1rem",
    },
          }}
        >
           {nosotros.subtitulo}
        </Typography>
      </Box>
      <Box
        sx={{
          marginTop: '50px',
           '@media (max-width:900px)': {
        padding:'0px 50px'
    },
     '@media (max-width:500px)': {
        padding:'0px 20px'
    },

        }}>
        <Grid container >
          <Grid size={{ sm: 12, md: 6 }} sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
            <Box className='ImagenNosotros'>
                {nosotros.imagen && (
                                                                <img
                                                                    src={`${backendURL}/${nosotros.imagen}`}
                                                                    alt="Hod maquinas dispensadoras" title='"Hod maquinas dispensadoras'
                                                                    
                                                                />
                                                            )}
           
            </Box>
          </Grid>
          <Grid size={{ sm: 12, md: 6 }}>
            <Box>
              <Typography
                variant="body1" // Tamaño grande para el título
                sx={{
                  fontFamily: 'Montserrat', // Establece la tipografía
                  fontWeight: "400", // Puedes ajustar el peso si lo necesitas
                  textAlign: 'justify',
                  color: "#1A425B", // Asegúrate de que sea blanco sobre el fondo oscuro
                }}
              >
               {nosotros.parrafo}
                <strong style={{marginLeft:'5px'}}> 
                  {nosotros.parrafo_destacado}
                </strong>
              </Typography>
              <Typography
                variant="body1" // Tamaño grande para el título
                sx={{
                  marginTop: '20px',
                  fontFamily: 'Montserrat', // Establece la tipografía
                  fontWeight: "400", // Puedes ajustar el peso si lo necesitas
                  textAlign: 'justify',
                  color: "#1A425B", // Asegúrate de que sea blanco sobre el fondo oscuro
                }}
              >
                {nosotros.parrafo2}
                <strong style={{marginLeft:'5px'}}> 
                   {nosotros.parrafo2_destacado}
                </strong>
              </Typography>
              <Typography
                variant="body1" // Tamaño grande para el título
                sx={{
                  marginTop: '20px',
                  fontFamily: 'Montserrat', // Establece la tipografía
                  fontWeight: "400", // Puedes ajustar el peso si lo necesitas
                  textAlign: 'justify',
                  color: "#1A425B", // Asegúrate de que sea blanco sobre el fondo oscuro
                }}
              >
                {nosotros.parrafo3}
                <strong style={{marginLeft:'5px'}}> 
                  {nosotros.parrafo3_destacado}
                </strong>
              </Typography>

              <Typography
                variant="body1" // Tamaño grande para el título
                sx={{
                  marginTop: '20px',
                  fontFamily: 'Montserrat', // Establece la tipografía
                  fontWeight: "400", // Puedes ajustar el peso si lo necesitas
                  textAlign: 'justify',
                  color: "#1A425B", // Asegúrate de que sea blanco sobre el fondo oscuro
                }}
              >
                 {nosotros.parrafo4}
                <strong style={{marginLeft:'5px'}}> 
                  {nosotros.parrafo4_destacado}
                </strong>
              </Typography>
              



            </Box>
          </Grid>
        </Grid>

      </Box>
    </Container>
  );
};